import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';
import EmailMetrics, { type MetricCardArgs } from './email_metrics';
import EmailIndex from './email_index';
import './styles.scss';
import { Dropdown, DropdownButton } from 'react-bootstrap-5';

export default function PropertyEmailIndex() {
  const metrics: MetricCardArgs[] = [
    { label: 'Total Sent', value: '0', infoLabel: 'Total number of emails sent' },
    { label: 'Delivered', value: '0%', infoLabel: 'Successfully delivered emails' },
    { label: 'Opens', value: '0%', infoLabel: 'Number of opens recorded' },
    { label: 'Clicks', value: '0%', infoLabel: 'Unique link clicks' },
    { label: 'Bounced', value: '0%', infoLabel: 'Emails that bounced' },
    { label: 'Unsubscribes', value: '0%', infoLabel: 'Users who unsubscribed' },
  ];

  const renderHeader = () => {
    return (
      <div className="email-tab-title-header">
        <h1 className="email-tab-title">Email Performance</h1>
        <DropdownButton title={<FontAwesomeIcon icon={faEllipsisV} />} variant="ghost btn-icon">
          <Dropdown.Item key="archive" onClick={() => {}}>
            Archive
          </Dropdown.Item>
          <Dropdown.Item key="notifications" onClick={() => {}}>
            Notifications
          </Dropdown.Item>
        </DropdownButton>
      </div>
    );
  };

  return (
    <div className="email-tab">
      <div className="email-tab-header">
        {renderHeader()}
        <div className="metrics-container">
          {metrics.map(EmailMetrics)}
        </div>
      </div>
      <EmailIndex />
    </div>
  );
}
